module.exports = __webpack_public_path__ + "static/button-left-8ae8fc6586a60da5ab7b0a5c1325b890.png";